"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDaysInMonth = exports.changeTimeZone = exports.MINUTE_IN_MS = exports.HOUR_IN_MS = exports.DAY_IN_MS = void 0;
exports.DAY_IN_MS = 24 * 60 * 60 * 1000;
exports.HOUR_IN_MS = 60 * 60 * 1000;
exports.MINUTE_IN_MS = 60 * 1000;
const changeTimeZone = (date, timeZone) => {
    if (typeof date === "string") {
        return new Date(new Date(date).toLocaleString("en-US", {
            timeZone,
        }));
    }
    return new Date(date.toLocaleString("en-US", {
        timeZone,
    }));
};
exports.changeTimeZone = changeTimeZone;
const getDaysInMonth = (month, year) => year && month ? new Date(year, month, 0).getDate() : 31;
exports.getDaysInMonth = getDaysInMonth;
//# sourceMappingURL=date.js.map